interface DotBreadcrumbsProps {
  currentStep: number;
  totalSteps: number;
}
const DotBreadcrumbs: React.FunctionComponent<DotBreadcrumbsProps> = ({ currentStep, totalSteps }) => {
 
  return (
    
    <div className="dot-breadcrumbs">
      {Array.from({ length: totalSteps }).map((_, i) => (
        <div
          key={i}
          className={`dot-breadcrumbs__dot ${i < currentStep ? "dot-breadcrumbs__dot--marked" : ""}`}
        ></div>
      ))}
    </div>
    
  );
};

export default DotBreadcrumbs;
